import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import constants from "../../core/constants";
import moment from "moment";

class BookingsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { title: "User", name: "user" },
      { title: "Ride", name: "rideName" },
      { title: "Pickup", name: "pick_up" },
      { title: "Dropoff", name: "drop_off" },
      { title: "Status", name: "status" },
      { title: "Price", name: "price", isSortable: true },
      { title: "Payment", name: "payment" },
      { title: "Promotion", name: "promotion" },
      { title: "Extra Paid", name: "extra_paid" },
      { title: "Seat", name: "seat_count" },
      { title: "Code", name: "boarding_pass" },
      { title: "Package", name: "commuter_package_amount" },
    ];
    this.insideFields = [
      { title: "User", name: "user", quickview: true },
      { title: "Ride", name: "rideName" },
      { title: "Pickup", name: "pick_up" },
      { title: "Dropoff", name: "drop_off" },
      { title: "Status", name: "status" },
      { title: "Price", name: "price", isSortable: true },
      { title: "Payment", name: "payment" },
      { title: "Phone", name: "phone" },
      { title: "Extra Paid", name: "extra_paid" },
      { title: "Seat", name: "seat_count" },
      { title: "Code", name: "boarding_pass" },
    ];
    this.dynamicRideBookingsFields = [
      { title: "User", name: "user", quickview: true },
      { title: "Ride", name: "rideName" },
      { title: "Pickup", name: "pick_up" },
      { title: "Promised ETA", name: "promised_pick_up" },
      { title: "Dropoff", name: "drop_off" },
      { title: "Promised ETD", name: "promised_drop_off" },
      { title: "Status", name: "status" },
      { title: "Price", name: "price", isSortable: true },
      { title: "Payment", name: "payment" },
      { title: "Phone", name: "phone" },
      { title: "Extra Paid", name: "extra_paid" },
      { title: "Seat", name: "seat_count" },
      { title: "Code", name: "boarding_pass" },
    ];
    this.filters = [
      {
        name: "user",
        title: "User",
        icon: "person",
        resource: "User",
        hasExact: true,
        exactFields: ["name", "email", "phone"],
        size: 25,
      },
      {
        name: "promotion",
        title: "Promotion",
        icon: "bubble_chart",
        resource: "Promotion",
        size: 25,
      },
      {
        name: "status",
        title: "Status",
        icon: "person",
        list: "bookingStatus",
        multiple: true,
      },
      { name: "date", title: "Select date", icon: "date_range", isDate: true },
      {
        name: "payment",
        title: "Payment",
        icon: "credit_card",
        list: "payments",
      },
      {
        name: "cash_collection_status",
        title: "Cash Collection Status",
        icon: "monetization_on",
        list: "cashCollectionStatus",
        multiple: true,
      },
      {
        name: "private_bus_request",
        title: "Private Bus Request",
        icon: "airport_shuttle",
        list: "isPrivateBusReq",
      },
    ];
    this.pendingBookingsFields = [
      { title: "User", name: "user" },
      { title: "Ride", name: "rideName" },
      { title: "Email", name: "email" },
      { title: "Phone", name: "phone" },
    ];
  }
  justify(data, rideId) {
    const format = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.date = moment(item.date).format(constants.dateTimeFormat);
      item.price = item.receipt.paid / constants.currencyBy;
      item.priceNum = item.price;
      item.extra_paid /= constants.currencyBy;
      let currency = "";
      if (item.ride) {
        item.rideName = `${item.ride.route.name} ${moment(
          item.ride.date
        ).format(constants.dateTimeFormat)}`;
        if (item.ride.currency) {
          item.price = `${item.price} ${item.ride.currency}`;
          item.extra_paid = `${item.extra_paid} ${item.ride.currency}`;
          currency = item.ride.currency;
        }

        if (rideId !== item.ride._id && item.is_transferred) {
          item.status = "transferred";
        }
      } else if (item.dynamic_trip && item.dynamic_trip.route) {
        item.rideName = `${item.dynamic_trip.route.name}`;
        item.price = `${item.price} ${item.dynamic_trip.route.currency}`;
        item.extra_paid = `${item.extra_paid} ${item.dynamic_trip.route.currency}`;
        currency = item.dynamic_trip.route.currency;
      }

      item.extraPaidNum = item.extra_paid;
      if (item.user) {
        item.phone = item.user.phone;
      }

      if (
        item.commuter_package_subscription &&
        typeof item.receipt.commuter_package_discount === "number"
      ) {
        item.commuter_package_amount = `${
          item.receipt.commuter_package_discount / constants.currencyBy
        } ${currency}`;
      } else {
        item.commuter_package_amount = "No";
      }

      if (item.pick_up) {
        if (item.pick_up_time) {
          item.pick_up = `${item.pick_up.name} at ${moment(
            item.pick_up_time
          ).format(constants.timeFormat)}`;
        }
      }
      if (item.promised_pick_up_time) {
        item.promised_pick_up = moment(item.promised_pick_up_time).format(
          constants.timeFormat
        );
      }
      if (item.promised_drop_off_time) {
        item.promised_drop_off = moment(item.promised_drop_off_time).format(
          constants.timeFormat
        );
      }
      if (item.drop_off) {
        if (item.drop_off_time) {
          item.drop_off = `${item.drop_off.name} at ${moment(
            item.drop_off_time
          ).format(constants.timeFormat)}`;
        }
      }

      if (item.payment) {
        item.payment.name = item.payment.name
          ? item.payment.name.substr(item.payment.name.length - 4)
          : null;
      }
      if (!item.boarding_pass) {
        item.boarding_pass = item._id.slice(-2);
      }

      return item;
    };

    return map(format)(data);
  }
}

export default BookingsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bookings/bookings.transforms.js